/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 10/01/2014
 * Time: 08:09
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services')
    .factory('CureView',
        ["$sce", "CureData", "CureSrv", "Cure", "SupplierView", "$filter", "$locale","ServiceData","CurrencyManager","NumberSeparatorType",
        function ($sce, CureData, CureSrv, Cure, SupplierView, $filter, $locale,ServiceData,CurrencyManager,NumberSeparatorType) {
            var CureView = function (cure, cIndex, parentCategoryView, domainView) {
                this.cIndex = cIndex;
                this.domainView = domainView;
                this.categoryType = "cure";
                this.categoryTypeSortOrder = 2;
                this.label = "";
                this.code = "";
                this.description = "";
                this.descriptionHtml = "";
                this.price = 0;
                this.priceInput = $filter("currencyFormatFilter")(0);
                this.hasInternetPrice = false;
                this.internetPrice = 0;
                this.internetPriceInput = $filter("currencyFormatFilter")(0);
                this.internetDiscountPercent = 0;
                this.companyImage = null;
                this.imageDisplayed = null; //eguals to companyImage if defined else GlobalImage
                this.specificImage = null;
                this.isVisibleOnWebSite = true;
                this.isBuyableOnWebSite = true;
                this.isOnHome = false;
                this.homeOrder = 0;
                //for views
                this.isSelected = false;
                this.isSmsSelected = false;
                this.isNotificationSelected = false;
                this.cureToServicesView = [];
                this.cureToServicesPrice = 0;
                this.cureToServicesToolTip = "";
                this.cureToServicesQuantity = 0;
                this.canSave = false;
                this.form = {
                    displayError : false,
                    displayErrorInternetPrice : false
                };
                if (parentCategoryView) {
                    this.parentCategoryView = parentCategoryView;
                }
                if (cure) {
                    this.loadDataFrom(cure);
                }
            }
            CureView.prototype.getModel = function() {
                if (this.cIndex != -1) {
                    return CureData.getByIndex(this.cIndex);
                }
                return null;
            }

            CureView.prototype.loadDataFrom = function(cure) {
                //Assume here than the object in parameter contains only id (must load them)
                this.label = cure.label;
                this.code = cure.code;
                this.description= cure.description;
                this.isVisibleOnWebSite = cure.isVisibleOnWebSite;
                this.isBuyableOnWebSite = cure.isBuyableOnWebSite;
                if (this.description) {
                    this.descriptionHtml = $sce.trustAsHtml(this.description.replace("\n","<br/>"));
                }
                this.price = cure.price;
                this.priceInput = $filter('currencyFormatFilter')(this.price);
                if (cure.internetPrice != null) {
                    this.internetPrice = cure.internetPrice;
                    if (this.internetPrice == 0 && this.price != 0) {
                        this.internetDiscountPercent = 100;
                    } else {
                        this.internetDiscountPercent = Math.round(10000 * (100 - 100 * this.internetPrice / this.price)) / 10000;
                    }
                } else {
                    this.internetPrice = this.price;
                }
                this.internetPriceInput = $filter('currencyFormatFilter')(this.internetPrice);
                this.isOnHome = cure.isOnHome;
                this.homeOrder = cure.homeOrder;
                this.hasInternetPrice = cure.hasInternetPrice;
                this.specificImage = cure.specificImage;
                this.image = cure.image;
                this.companyImage = cure.companyImage;
                //for ascendencing compatibility
                if (this.image || this.companyImage) {
                    this.specificImage = true;
                }
                if (this.parentCategoryView && this.image == null && this.specificImage == false) {
                    this.image = this.parentCategoryView.image;
                }
                if (this.parentCategoryView && this.companyImage == null && this.specificImage == false) {
                    this.companyImage = this.parentCategoryView.companyImage;
                }
                this.imageDisplayed = (this.companyImage) ? this.companyImage : this.image;
                this.updateCureToServicesView(cure);
            }

            /**
             * Pour toutes les prestations (cureToServices: Array) de la cure on récupère la vue 
             * de la prestation (serviceView: Object) et on la stocke dans (cureToServicesView: Array).
             *
             * @param cure the cure model
             */
            CureView.prototype.updateCureToServicesView = function(cure) {
                this.cureToServicesView = [];
                cure.cureToServices.forEach( (element) => {
                    let serviceView = this.domainView.getServiceView(element.service);
                    if (serviceView) {
                        serviceView.addLinkToCureView(this);
                    }
                    let cureToServiceView = {
                        serviceView: serviceView,
                        quantity: element.quantity
                    };
                    this.cureToServicesView.push(cureToServiceView);
                    //update all fields
                    this.onChangeQuantity(cureToServiceView);
                });
            }

            CureView.prototype.updateCureToServicesToolTip = function() {
                this.cureToServicesToolTip = "";
                for (var i=0;i<this.cureToServicesView.length;i++)
                {
                    if (this.cureToServicesView[i].serviceView)
                    {
                        this.cureToServicesToolTip += this.cureToServicesView[i].serviceView.label + "(" + this.cureToServicesView[i].quantity + ")";
                        if ((i+1)<this.cureToServicesView.length)
                            this.cureToServicesToolTip += ", "
                    }
                }

            };

            CureView.prototype.updatePriceInputArrow = function(number)
            {
                if (this.priceInput!=null && typeof this.priceInput ==='string') {
                    var priceStr = CurrencyManager.getPriceFromPriceInput(this.priceInput);;
                    var price = parseFloat(priceStr);
                    if(price !== "NaN")
                        price+= number;

                    this.priceInput = $filter('currencyFormatFilter')(price);
                    this.onPriceInputChange();
                }
            }
            
            CureView.prototype.onPriceInputChange = function()
            {
                if (this.priceInput!=null && typeof this.priceInput ==='string') {
                    var priceStr = CurrencyManager.getPriceFromPriceInput(this.priceInput);
                    var price = parseFloat(priceStr);
                    if(price !== "NaN")
                        this.price = price;
                    else
                        this.price = null;
                }
                this.checkHasWrongInternetPrice();
                this.updateCanSave();

            };

            CureView.prototype.isChanged = function()
            {
                var cure = this.getModel();
                if (cure)
                {
                    var image = cure.image;
                    if (image==null &&cure.parentCategory&& cure.specificImage== false)
                        image = cure.parentCategory.image;
                    var companyImage = cure.companyImage;
                    if (companyImage==null &&cure.parentCategory&& cure.specificImage== false)
                        companyImage = cure.parentCategory.companyImage;

                    return (
                        this.label != cure.label ||
                        this.description!= cure.description ||
                        this.price!= cure.price ||
                        this.specificImage!= cure.specificImage ||
                        this.hasInternetPrice!= cure.hasInternetPrice ||
                        this.internetPrice!= cure.internetPrice ||
                        this.image !== image ||
                        this.companyImage !== companyImage);
                }
                else
                    return true;

            }
            CureView.prototype.setImage = function(image)
            {
                this.image = image;
                this.companyImage = null;
                this.imageDisplayed = this.image;
            }
            CureView.prototype.setCompanyImage = function(companyImage)
            {
                this.image = null;
                this.companyImage = companyImage;
                this.imageDisplayed = this.companyImage;
            }
            CureView.prototype.initInternetPrice = function()
            {
                if (this.hasInternetPrice && this.internetPrice==0)
                {
                    this.internetPrice = this.price;
                    this.internetPriceInput = $filter('currencyFormatFilter')(this.internetPrice);
                    this.onInternetPriceInputChange();
                }
                this.checkHasWrongInternetPrice();
                this.updateCanSave();
            };

            CureView.prototype.updateInternetPriceInputArrow = function(number)
            {
                if (this.internetPriceInput!=null && typeof this.internetPriceInput ==='string') {
                    var internetPriceStr = CurrencyManager.getPriceFromPriceInput(this.internetPriceInput);
                    var internetPrice = parseFloat(internetPriceStr);
                    if(internetPrice !== "NaN")
                        if ((internetPrice+number) < 0)
                            internetPrice = 0;
                        else{
                            if ((internetPrice+number) < this.price)
                                internetPrice+= number;
                            else
                                internetPrice = this.price;
                        }
                    this.internetPriceInput = $filter('currencyFormatFilter')(internetPrice);
                    this.onInternetPriceInputChange();
                }
            };
            CureView.prototype.onInternetPriceInputChange = function()
            {
                if (this.internetPriceInput!=null && typeof this.internetPriceInput ==='string') {
                    var internetPriceStr = CurrencyManager.getPriceFromPriceInput(this.internetPriceInput);
                    var internetPrice = parseFloat(internetPriceStr);
                    if(internetPrice !== "NaN")
                        this.internetPrice = internetPrice;
                    else
                        this.internetPrice = null;
                    if (this.internetPrice==0 && this.price!=0)
                        this.internetDiscountPercent = 100;
                    else
                        this.internetDiscountPercent = Math.round(100*(100- 100* this.internetPrice/this.price))/100;
                }
                this.checkHasWrongInternetPrice();
                this.updateCanSave();
            };

            CureView.prototype.copyDataTo = function(cure) {
                //Assume here than the object in parameter contains only id (must load them)
                cure.label = this.label;
                cure.code = this.code;
                cure.description = this.description;
                cure.price= this.price;
                cure.image = this.image;
                cure.companyImage = this.companyImage;
                cure.specificImage = this.specificImage;
                cure.hasInternetPrice = this.hasInternetPrice;
                cure.isOnHome = this.isOnHome;
                cure.homeOrder = this.homeOrder;
                cure.internetPrice= this.internetPrice;
                cure.isVisibleOnWebSite = this.isVisibleOnWebSite;
                cure.isBuyableOnWebSite = this.isBuyableOnWebSite;
                cure.cureToServices = [];
                this.cureToServicesView.forEach( (element) => {
                    if (element.serviceView) {
                        cure.cureToServices.push({
                            service: element.serviceView.getModel(),
                            quantity: element.quantity
                        });
                        element.serviceView.addLinkToCureView(this);
                    }
                });
            }

            CureView.prototype.onSpecificImageChange = function()
            {
                if (!this.specificImage)
                {
                    this.image = null;
                    this.companyImage = null;
                }
            }

            CureView.prototype.updateModel = function() {
                var cure = this.getModel();
                if (cure == null) {
                    cure = new Cure();
                    this.cIndex = CureData.getIndexOf(cure);
                }
                if (!this.specificImage && this.parentCategoryView !== undefined 
                    && this.parentCategoryView.label !== "Racine") {
                    this.image = this.parentCategoryView.image;
                    cure.image = this.image;
                }
                this.copyDataTo(cure);

                var category = this.parentCategoryView.getModel();
                // change of category
                if (category && category !== cure.parentCategory) {
                    if (cure.parentCategory) {
                        cure.parentCategory.removeCure(cure);
                    }
                    category.addCure(cure);
                }
                CureSrv.save(cure);
            }

            CureView.prototype.removeModel = function()
            {
                var cure = this.getModel();
                if (cure!=null)
                {
                    cure.parentCategory.removeCure(cure);
                    CureSrv.remove(cure);
                }
            }
            
            CureView.prototype.reloadModel = function() {
                var cure = this.getModel();
                if (cure == null) {
                    this.parentCategoryView.removeCureView(this);
                } else {
                    this.loadDataFrom(cure);
                }
            }
            
            CureView.prototype.restoreModel = function() {
                //undeleted
                var cure = this.getModel();
                if (cure) {
                    if (cure.parentCategory) {
                        cure.parentCategory.addCure(cure);
                    }
                    CureSrv.restore(cure);
                }
            }

            CureView.prototype.checkHasWrongInternetPrice = function(){
                if(this.hasInternetPrice && (this.internetPrice === 0 || this.internetPrice == null) && this.price === 0){
                    this.form.displayErrorInternetPrice = true;
                }else{
                    this.form.displayErrorInternetPrice = false;
                }
            };

            CureView.prototype.updateCanSave = function() {
                let quantityInt = parseInt(this.quantity);
                if (quantityInt !== "NaN" && quantityInt !== "") {
                    this.quantity = quantityInt;
                } else {
                    this.quantity = null;
                }

                if ((this.label && this.label !== "") //titre
                    && (this.price != null && this.price >= 0 &&  //prix (décimal)
                    this.cureToServicesQuantity !== 0 && !this.form.displayErrorInternetPrice)) {
                    this.canSave = true;
                } else {
                    this.canSave = false;
                }
            };

            CureView.prototype.search = function (searchedTextLC) {
                return (searchedTextLC && this.label && this.label.toLowerCase().indexOf(searchedTextLC) != -1)
                     || (this.image && this.image.keyWords && this.image.keyWords.indexOf(searchedTextLC) != -1);
            }

            CureView.prototype.updateCureToServiceVar = function () {
                this.cureToServicesPrice = 0;
                this.cureToServicesQuantity = 0;
                this.cureToServicesView.forEach( (element) => {
                    this.cureToServicesQuantity += element.quantity;
                    this.cureToServicesPrice += element.price;
                });
            }

            CureView.prototype.addServiceViewOnCure = function(serviceView) {
                let existingCtS = this.cureToServicesView.find( (element) => element.serviceView == serviceView);
                if (existingCtS) {
                    existingCtS.quantity++;
                    this.onChangeQuantity(existingCtS);
                } else {
                    var service = ServiceData.getById(serviceView.serviceId);
                    this.cureToServicesView.push({
                        serviceView: serviceView,
                        quantity: 1,
                        price: serviceView.price
                    });
                    if(this.getModel()) {
                        this.getModel().serviceTab.push(service);
                        service.cures.push(this.getModel())
                    }
                }
                this.updateCureToServiceVar();
                this.updateCureToServicesToolTip();
                this.updateCanSave();
            };

            CureView.prototype.removeServiceViewOnCure = function(cureToServiceView) {
                this.cureToServicesView = this.cureToServicesView.filter( (element) => element !== cureToServiceView);
                var service = null;
                if (cureToServiceView && cureToServiceView.serviceView) {
                    cureToServiceView.serviceView.removeLinkToCureView(this);
                    service = ServiceData.getById(cureToServiceView.serviceView.serviceId);
                    let cure = this.getModel();
                    if (cure && service && service.cures) {
                        for (let i = 0; i < service.cures.length; i++) {
                            if (service.cures[i].id === cure.id) {
                                for (let j = 0; j < service.cures[i].serviceTab.length; j++) {
                                    if (service.cures[i].serviceTab[j].id === cureToServiceView.serviceView.serviceId) {
                                        service.cures[i].serviceTab.splice(j, 1)
                                    }
                                }
                                service.cures.splice(i, 1)
                            }
                        }
                    }

                    this.updateCureToServiceVar();
                    this.updateCureToServicesToolTip();
                    this.updateCanSave();
                }
            };


            CureView.prototype.onChangeQuantity = function (cureToServiceView) {
                if (cureToServiceView && cureToServiceView.serviceView) {
                    cureToServiceView.price = cureToServiceView.serviceView.price * cureToServiceView.quantity;
                }
                this.updateCureToServiceVar();
                this.updateCureToServicesToolTip();
                this.updateCanSave();
            }
            return CureView;
        }
]);



// WEBPACK FOOTER //
// ./js/services/views/CureView.js